import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

/**
 * Bot-edit sub-page: shown only when the active bot is an alpha_dozent.
 * Hosts the shared twin-linked-tutors component, which handles both the
 * admin attach/detach flow and the rights-limited link-request flow
 * (branching on AuthService.isClientWide() internally).
 */
@Component({
  selector: 'app-linked-tutors',
  templateUrl: './linked-tutors.component.html',
  styleUrl: './linked-tutors.component.scss',
})
export class LinkedTutorsComponent implements OnInit {
  dozentBotId!: string;

  constructor(private activeRoute: ActivatedRoute) {}

  ngOnInit(): void {
    this.dozentBotId = this.activeRoute.parent!.snapshot.paramMap.get('tutorId')!;
  }
}
